export default "__VITE_ASSET__DH5IExc7__"